import get from 'lodash/get';
import algoliasearchHelper from '@dkrm/algoliasearch-helper';
let algoliasearch = null;
if (__NATIVE__) {
  algoliasearch = require('algoliasearch/reactnative');
} else {
  algoliasearch = require('algoliasearch');
}
const K_DEFAULT_SEARCH_OPTIONS = {
  shouldBuildDisjunctiveRefinementList: false,
  shouldBuildHierarchicalRefinementList: false
};
const fetchSearchResults = (algoliaAppName, algoliaAPIKey, searchParameters, searchIndex, searchOptions = K_DEFAULT_SEARCH_OPTIONS) => {
  const helper = createHelper(algoliaAppName, algoliaAPIKey, searchIndex, searchOptions);
  helper.setState(searchParameters);
  helper.setIndex(searchIndex);

  // quick fix for client that use search functionality without searchAdapter
  // page that set inside searchParameters is useless, must be set inside the helper explicitly
  if ('page' in searchParameters && searchParameters.page >= 0) {
    helper.setPage(searchParameters.page);
  }
  const promise = new Promise((resolve, reject) => {
    helper.on('result', result => {
      /** simulate searchOnce result to prevent break
       * since the codes were previously using searchOnce */
      resolve({
        content: result,
        state: helper.state,
        _originalResponse: {
          results: get(result, '_rawResults')
        }
      });
    });
    helper.on('error', err => {
      reject(err);
    });
  });
  helper.search();
  return promise;
};
const createHelper = (algoliaAppName, algoliaAPIKey, searchIndex, searchOptions) => {
  const algolia = algoliasearch(algoliaAppName, algoliaAPIKey, {
    timeouts: {
      connect: 3000,
      read: 5000,
      write: 30000
    }
  });
  const helper = algoliasearchHelper(algolia, searchIndex, {
    searchOptions
  });
  return helper;
};
export default fetchSearchResults;